import React, { useEffect, useState } from "react";
import Select from "react-select";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { indian_states } from "../../components/Data/IndianStates";
import { countries } from "../../components/Data/Countries";
import { gbState } from "../../components/shared/GlobalState";
import { FaUser, FaCalendarAlt, FaEnvelope } from "react-icons/fa";

const ProfileUpdate = () => {
  const [{ errorLogApi, user, bloodgroupOptions }] = useAtom(gbState);
  let navigate = useNavigate();
  const familyDetails = [];
  const [formData, setFormData] = useState({});
  const [userData, setUserData] = useState({});
  const [fmData, setFmData] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [cityOptions, setCityOptions] = useState();
  const [cityStateInput, setCityStateInput] = useState(false);
  const [churchList, setChurchList] = useState();
  const inputWidth = "230px";
  //Error Logging Service & Santize Input
  const placeHolderText = (text) => (
    <span className="text-sm text-light">{text}</span>
  );
  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid lightgray",
      // This line disable the blue border
      boxShadow: "none",
    }),
  };

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const urlLink = `${process.env.REACT_APP_API_URL}/user/${user._id}`;
    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        const dataRecieved = response?.data?.users;
        setUserData(dataRecieved);
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });

    const urlLink1 = `${process.env.REACT_APP_API_URL}/family/primaryMember/${user._id}`;
    const config1 = {
      method: "GET",
      url: urlLink1,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config1)
      .then(function (response) {
        const oldData = response.data.families;
        setFmData({ ...oldData[0] });
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  }, []);

  useEffect(() => {
    setFormData({
      ...formData,
      ...userData,
      ...fmData,
    });
  }, [userData, fmData]);

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/churches/`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      // data: { ...formData },
    };

    axios(config)
      .then(function (response) {
        //console.log(response.data);
        const churches = response.data.churches;
        setChurchList(
          churches.map((church) => ({
            value: church._id,
            label: church.church_name + " (" + church.city + ")",
          }))
        );
      })
      .catch(function (error) {
        toast.error(JSON.stringify(error.response.data));
        errorLogApi(error, "ChurchList", "/churches");
      });
  }, []);
  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };
  const indianStates = Object.keys(indian_states);

  const indianStatesOption = indianStates.map((data, index) => {
    return { value: data, label: data };
  });
  const inputElementWidthStyle = `w-full p-3 h-10 font-sans text-sm font-light border border-gray-300 rounded-md outline-none`;

  const countriesOption = countries.map((country) => ({
    value: country.code,
    label: country.name,
  }));

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "nonbinary", label: "Non-binary" },
    { value: "other", label: "Other" },
  ];

  const dayOptions = [];
  for (var i = 1; i <= 31; i++) {
    if (i < "10") i = "0" + i;

    dayOptions.push({ value: i, label: i });
  }
  const monthOptions = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const dropDownChange = (selected, dropdown) => {
    setFormData({
      ...formData,
      [dropdown.name]: selected.value,
    });
  };

  const binaryOptions = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];

  useEffect(() => {
    if (formData?.country === "India") {
      setCityStateInput(true);
    } else {
      setCityStateInput(false);
    }
  }, [formData?.country]);

  useEffect(() => {
    //console.log(indian_states);
    setCityOptions(
      indian_states[formData?.state]?.map((d, i) => {
        return { value: d, label: d };
      })
    );
  }, [formData?.state]);

  const handleFamilyUpdate = () => {
    let userToken = localStorage.getItem("token");
    console.log(formData);
    if (
      user?.role === "CHURCH_MEMBER" ||
      user?.role === "SUB_MEMBER" ||
      user?.role === "CHURCH_ADMIN"
    ) {
      if (!formData.first_name) {
        toast.error("Please enter first name");
        return;
      }

      if (!formData.last_name) {
        toast.error("Please enter last name");
        return;
      }

      let config = {};
      if (selectedImage) {
        // Create FormData object
        const formDataObj = new FormData();

        // Append all form fields
        Object.keys(formData).forEach((key) => {
          if (formData[key] !== null && formData[key] !== undefined) {
            // Handle special cases for nested objects
            if (
              key === "primary_member_id" &&
              typeof formData[key] === "object"
            ) {
              formDataObj.append(key, formData[key]._id);
            } else if (
              key === "church_id" &&
              typeof formData[key] === "object"
            ) {
              formDataObj.append(key, formData[key]._id);
            } else if (typeof formData[key] === "object") {
              // Skip object fields that we don't want to send
              console.log("Skipping object field:", key);
            } else {
              formDataObj.append(key, formData[key]);
            }
          }
        });

        // Handle image upload
        if (selectedImage) {
          formDataObj.append("image", selectedImage);
        }

        config = {
          method: "patch",
          url: `${process.env.REACT_APP_API_URL}/family/update-profile/${formData._id}`,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${userToken}`,
          },
          data: formDataObj,
        };
      } else {
        config = {
          method: "patch",
          url: `${process.env.REACT_APP_API_URL}/family/update-profile/${formData._id}`,
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
          data: { ...formData },
        };
      }

      axios(config)
        .then(function (response) {
          //console.log(JSON.stringify(response.data));
          toast.success("Record Updated Successfully.");
          navigate("/member/dashboard");
        })
        .catch(function (error) {
          //  toast.error(JSON.stringify(error.response.data.message));
          toast.error(JSON.stringify(error?.response?.data));
          errorLogApi(error, "FamilyUpdateChild", "/member/dashboard");
          // console.log(error);
        });
    } else {
      if (!formData.first_name) {
        toast.error("Please enter first name");
        return;
      }
      if (!formData.last_name) {
        toast.error("Please enter last name");
        return;
      }
      if (!formData.mobile) {
        toast.error("Please enter mobile no");
        return;
      }
      if (!formData.email) {
        toast.error("Please enter email ID");
        return;
      }

      let config = {
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/employee/update/${formData._id}`,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userToken}`,
        },
        data: { ...formData, image: selectedImage },
      };

      axios(config)
        .then(function (response) {
          //console.log(JSON.stringify(response.data));
          toast.success("Record Updated Successfully.");
          navigate("/dashboard-ca");
        })
        .catch(function (error) {
          //  toast.error(JSON.stringify(error.response.data.message));
          toast.error(JSON.stringify(error?.response?.data));
          errorLogApi(error, "FamilyUpdateChild", "/updateProfile");
          // console.log(error);
        });
    }
  };
  const statusOptions = [
    { value: 1, label: "Active" },
    { value: 0, label: "Inactive" },
  ];
  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };

  const selectStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "#F9FAFB",
      borderColor: "#D1D5DB",
      "&:hover": {
        borderColor: "#3B82F6",
      },
    }),
  };

  return (
    <div className="flex w-full min-h-screen bg-gray-100">
      <div className="w-full max-w-4xl p-8 mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-3xl font-bold text-gray-800">Update Profile</h1>
          <div className="space-x-4">
            <button
              className="px-4 py-2 text-gray-600 transition duration-150 ease-in-out bg-white rounded-lg shadow hover:bg-gray-50"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
            <button
              className="px-4 py-2 text-white transition duration-150 ease-in-out bg-blue-600 rounded-lg shadow hover:bg-blue-700"
              onClick={handleFamilyUpdate}
            >
              Save Changes
            </button>
          </div>
        </div>

        <div className="p-6 bg-white rounded-lg shadow-md">
          <form>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
              <div className="col-span-2">
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  Profile Image
                </label>
                <input
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  name="event_image"
                  type="file"
                  onChange={handleImageChange}
                  accept="image/jpeg, image/png"
                />
              </div>

              <div>
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  <FaUser className="inline mr-2" />
                  First Name
                </label>
                <input
                  type="text"
                  name="first_name"
                  placeholder="First Name"
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  value={formData?.first_name}
                />
              </div>

              <div>
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  <FaUser className="inline mr-2" />
                  Last Name
                </label>
                <input
                  type="text"
                  name="last_name"
                  placeholder="Last Name"
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  value={formData?.last_name}
                />
              </div>

              {user?.user_role === "CHURCH_ADMIN" && (
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-700">
                    <FaCalendarAlt className="inline mr-2" />
                    Date of Birth
                  </label>
                  <DatePicker
                    className="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    name="date_of_birth"
                    onChange={(date, dateString) => {
                      setFormData({
                        ...formData,
                        date_of_birth: dateString,
                      });
                    }}
                    format="DD-MM-YYYY"
                    value={
                      formData?.date_of_birth &&
                      dayjs(formData?.date_of_birth, "DD-MM-YYYY")
                    }
                  />
                </div>
              )}

              {user?.user_role !== "CHURCH_ADMIN" && (
                <div>
                  <label className="block mb-2 text-sm font-medium text-gray-700">
                    Date of Birth
                  </label>
                  <div className="flex space-x-2">
                    <Select
                      name="birth_month"
                      onChange={dropDownChange}
                      options={monthOptions}
                      className="w-1/3"
                      placeholder="Month"
                      styles={selectStyles}
                      value={
                        formData.birth_month
                          ? {
                              value: formData.birth_month,
                              label: formData.birth_month,
                            }
                          : null
                      }
                    />
                    <Select
                      name="birth_day"
                      onChange={dropDownChange}
                      options={dayOptions}
                      className="w-1/3"
                      placeholder="Day"
                      styles={selectStyles}
                      value={
                        formData.birth_day
                          ? {
                              value: formData.birth_day,
                              label: formData.birth_day,
                            }
                          : null
                      }
                    />

                    <DatePicker
                      className="w-1/3 h-[38px] bg-gray-50 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                      name="birth_year"
                      onChange={(date, dateString) => {
                        setFormData({
                          ...formData,
                          birth_year: dateString,
                        });
                      }}
                      picker="year"
                      placeholder="Year"
                      value={
                        formData.birth_year ? dayjs(formData.birth_year) : null
                      }
                    />
                  </div>
                </div>
              )}

              <div>
                <label className="block mb-2 text-sm font-medium text-gray-700">
                  <FaEnvelope className="inline mr-2" />
                  Email
                </label>
                <input
                  type="text"
                  name="email"
                  className="w-full p-2 bg-gray-100 border border-gray-300 rounded-md"
                  value={formData?.email}
                  disabled
                />
              </div>

              {/* Add more fields here, following the same pattern */}
            </div>
            {/* <div className="">{JSON.stringify(user)}</div> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProfileUpdate;
